app.controller("EditGradeController", [
    "$scope", "$uibModalInstance", "params",
    function ($scope, $uibModalInstance, params) {
        var grade = params.grade;
        $scope.maxRelative = grade.relative;
        $scope.value = grade.grade.relative;
        $scope.comment = "";
        $scope.submit = function () {
            $uibModalInstance.close({
                comment:$scope.comment,
                value: $scope.value
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);